(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter-sort"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const filterForm = document.getElementById('CollectionFiltersForm');
    const productContainer = document.getElementById('product-container');
    const paginationContainer = document.getElementById('pagination-container');
    const sortSelect = document.getElementById('sorting');

    const sectionId = filterForm?.dataset.sectionId;
    if (!filterForm || !sectionId || !productContainer) return;

    const fetchFilteredProducts = () => {
      const params = new URLSearchParams(new FormData(filterForm));

      if (sortSelect && sortSelect.value && sortSelect.value !== 'manual') {
        params.set('sort_by', sortSelect.value);
      } else {
        params.delete('sort_by');
      }

      fetch(`${window.location.pathname}?section_id=${sectionId}&${params.toString()}`)
        .then((res) => res.text())
        .then((html) => {
          const tempDOM = document.createElement('div');
          tempDOM.innerHTML = html;

          const newProducts = tempDOM.querySelector('#product-container');
          const newPagination = tempDOM.querySelector('#pagination-container');
          const newProductCount = tempDOM.querySelector('#product-count');

          if (newProducts) productContainer.innerHTML = newProducts.innerHTML;
          if (newPagination) paginationContainer.innerHTML = newPagination.innerHTML;

          window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
        });
    };

    filterForm.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', fetchFilteredProducts);
    });

    filterForm.querySelectorAll('input[type="number"]').forEach((input) => {
      input.addEventListener('change', fetchFilteredProducts);
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', fetchFilteredProducts);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lang-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('localization-form')) {
    customElements.define(
      'localization-form',
      class LocalizationForm extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('ul'),
          };

          if (!this.elements.button || !this.elements.panel || !this.elements.input) {
            console.error('LocalizationForm: Required elements not found');
            return;
          }

          this.elements.button.addEventListener('click', this.openSelector.bind(this));
          this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

          this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        }

        hidePanel() {
          if (this.elements.button && this.elements.panel) {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
          }
        }

        onContainerKeyUp(event) {
          if (event.code.toUpperCase() !== 'ESCAPE') return;

          if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
          this.hidePanel();
          event.stopPropagation();
          this.elements.button.focus();
        }

        onItemClick(event) {
          event.preventDefault();
          const form = this.querySelector('form');
          this.elements.input.value = event.currentTarget.dataset.value;
          if (form) form.submit();
        }

        openSelector() {
          this.elements.button.focus();
          const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';

          if (isExpanded) {
            this.hidePanel();
          } else {
            this.elements.panel.removeAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', 'true');
          }
        }

        closeSelector(event) {
          const isChild =
            event.relatedTarget &&
            (this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget));
          if (!event.relatedTarget || !isChild) {
            this.hidePanel();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
